import React from 'react';
import { 
  ArrowUpDown, ArrowUp, ArrowDown, Star, Globe,
  Instagram, Facebook, Youtube, Linkedin, Twitter, MessageCircle
} from 'lucide-react';
import { Badge } from '../../components/ui/badge';

// Stats Card Component
export const StatCard = ({ icon: Icon, label, value, color = 'primary', onClick }) => (
  <div 
    onClick={onClick}
    className={`bg-white rounded-xl p-4 shadow-sm border-l-4 ${color === 'red' ? 'border-red-500' : color === 'orange' ? 'border-orange-500' : color === 'green' ? 'border-green-500' : 'border-primary'} ${onClick ? 'cursor-pointer hover:shadow-md transition-shadow' : ''}`}
  >
    <div className="flex items-center gap-3">
      <div className={`p-2 rounded-lg ${color === 'red' ? 'bg-red-100' : color === 'orange' ? 'bg-orange-100' : color === 'green' ? 'bg-green-100' : 'bg-primary/10'}`}>
        <Icon className={`h-5 w-5 ${color === 'red' ? 'text-red-600' : color === 'orange' ? 'text-orange-600' : color === 'green' ? 'text-green-600' : 'text-primary'}`} />
      </div>
      <div>
        <p className="text-2xl font-bold text-gray-800">{value}</p>
        <p className="text-sm text-gray-500">{label}</p>
      </div>
    </div>
  </div>
);

// Sortable Table Header
export const SortableHeader = ({ label, sortKey, currentSort, onSort }) => {
  const isActive = currentSort.key === sortKey;
  return (
    <th 
      className="px-4 py-3 text-left text-sm font-semibold text-gray-700 cursor-pointer hover:bg-gray-100 select-none"
      onClick={() => onSort(sortKey)}
    >
      <div className="flex items-center gap-1">
        {label}
        {isActive ? (
          currentSort.direction === 'asc' ? <ArrowUp className="h-4 w-4" /> : <ArrowDown className="h-4 w-4" />
        ) : (
          <ArrowUpDown className="h-4 w-4 text-gray-400" />
        )}
      </div>
    </th>
  );
};

// Social Links Display
export const SocialLinksDisplay = ({ socialLinks }) => {
  if (!socialLinks || Object.keys(socialLinks).length === 0) return <span className="text-gray-400 text-sm">-</span>;
  
  const icons = {
    instagram: Instagram,
    facebook: Facebook,
    youtube: Youtube,
    linkedin: Linkedin,
    twitter: Twitter,
    tiktok: MessageCircle,
    telegram: MessageCircle
  };
  
  return (
    <div className="flex gap-2 flex-wrap">
      {Object.entries(socialLinks).map(([key, url]) => {
        if (!url) return null;
        const Icon = icons[key] || Globe;
        return (
          <a key={key} href={url} target="_blank" rel="noopener noreferrer" 
             className="p-1.5 bg-gray-100 rounded-full hover:bg-gray-200 transition-colors">
            <Icon className="h-4 w-4 text-gray-600" />
          </a>
        );
      })}
    </div>
  );
};

// Google Rating Display
export const GoogleRatingDisplay = ({ rating }) => {
  if (!rating) return <span className="text-gray-400 text-sm">-</span>;
  
  const ratingValue = rating.google_rating || rating;
  const reviewCount = rating.google_reviews_count || 0;
  const isVerified = rating.is_verified;
  
  return (
    <div className="flex items-center gap-2">
      <Star className={`h-4 w-4 ${isVerified ? 'text-yellow-500 fill-yellow-500' : 'text-gray-400'}`} />
      <span className={isVerified ? 'font-medium' : 'text-gray-500'}>{ratingValue}</span>
      {reviewCount > 0 && <span className="text-xs text-gray-400">({reviewCount})</span>}
      {!isVerified && <Badge variant="outline" className="text-xs">Pendiente</Badge>}
    </div>
  );
};
